import { createElement } from 'react';
import '../uniqueId.js';
import 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import '../Text/styled.js';
import '../Text/index.js';
import 'reakit/Navigation';
import '../Navigation/styled.js';
import '../chunk-18be6601.js';
import '../Navigation/index.js';
import 'conditional-wrap';
import '../adaptors/fields.js';
import 'reakit/Label';
import 'reakit/Input';
import 'reakit/Hidden';
import '../Hidden/HiddenContainer.js';
import '../Hidden/styled.js';
import '../Hidden/HiddenShow.js';
import '../Hidden/HiddenHide.js';
import '../Hidden/HiddenToggle.js';
import '../Hidden/index.js';
import '../chunk-5c9bbccf.js';
import 'reakit/Popover';
import '../Popover/PopoverContainer.js';
import '../Popover/styled.js';
import '../Popover/PopoverHide.js';
import '../Popover/PopoverClose.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Popover/PopoverPopover.js';
import '../Popover/PopoverShow.js';
import '../Popover/PopoverToggle.js';
import '../chunk-8dd1e1d3.js';
import '../chunk-1195bf9a.js';
import 'reakit/Field';
import '../Label/styled.js';
import '../Label/index.js';
import '../FieldWrapper/styled.js';
import 'reakit/Divider';
import '../Divider/styled.js';
import '../Divider/index.js';
import 'reakit/Group';
import '../Group/styled.js';
import '../Group/index.js';
import 'react-input-mask';
import '../Input/styled.js';
import '../Input/InputField-2fb729da.js';
import '../Input/index.js';
import '../Popover/index.js';
import '../Menu/styled.js';
import '../Menu/MenuContext.js';
import '../Menu/MenuTrigger.js';
import '../Menu/MenuButton.js';
import '../Menu/MenuDivider.js';
import '../Menu/MenuGroup.js';
import '../Menu/MenuItem.js';
import '../Menu/MenuPopover.js';
import '../Menu/index.js';
import '../Tag/styled.js';
import '../Tag/index.js';
import { SelectMenuIcon } from './styled.js';

var SelectIcon = (function () {
  return createElement(SelectMenuIcon, {
    viewBox: "0 0 20 20",
    focusable: "false",
    "aria-hidden": "true"
  }, createElement("path", {
    d: "M13 8l-3-3-3 3h6zm-.1 4L10 14.9 7.1 12h5.8z",
    fillRule: "evenodd"
  }));
});

export default SelectIcon;
